module.exports = __webpack_public_path__ + "static/media/illus-survey-complete.1d79b97d.png";